import { awExposureSearchApi } from './Base';
import { ExposureSearchStatus } from './Models';

export const getExposureSearchStatuses = () => {
  const path = '/api/v1/statuses';
  return awExposureSearchApi.get<ExposureSearchStatus[]>(path);
};

export const getBatchedExposureSearchStatuses = (batchId: string, pkg?: string) => {
  const path = `/api/v1/statuses/${batchId}`;
  return awExposureSearchApi.get<ExposureSearchStatus>(path, { params: { pkg } });
};
